import React from 'react';
import { Card, Col, Offcanvas, Row, Table } from 'react-bootstrap';
import LoadingOverlay from 'components/common/LoadingOverlay';
import CurrencyAmount from 'pages/Transactions/common/CurrencyAmount';
import StripeStatus from 'pages/Transactions/common/StripeStatus';
import dayjs from 'dayjs';
import { FORMAT_DATE_TIME_II } from 'constants';
import { renderRows, subsidyPaymentRows, subsidyTransactionRows } from './rowsConfig';

function SubsidyPaymentMethod({ cardNumber }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <span
        className="d-inline-block rounded-1"
        style={{ width: 30, height: 18, backgroundColor: '#f5b82e' }}
      />
      <span>{cardNumber ? `**** ${cardNumber}` : ''}</span>
    </div>
  );
}

function SubsidyTransactionDetail({ show, onHide, data, loading, ...props }) {
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      backdropClassName="custom-drawer"
      style={{ width: 980, maxWidth: '100%' }}
      {...props}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="d-flex align-items-center">
          <span className="me-1">Viewing subsidy transaction</span>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="position-relative">
        {loading && <LoadingOverlay />}
        <Card className="mb-3">
          <Card.Header className="p-2 d-flex align-items-center">
            <CurrencyAmount
              amount={data?.amount}
              symbol={data?.currencySymbol}
              classNames="fw-bold fs-1 text-900"
            />
            <span className="fs-1 text-700 text-uppercase ms-1 me-2">
              {data?.stripeInfo?.stripeCurrency}
            </span>
            <StripeStatus status={data?.transactionStatus} minWidth="135px" />
          </Card.Header>
          <Card.Body className="p-2 border-top">
            <div className="d-flex flex-wrap gap-3 fs--1">
              <div>
                <p className="mb-0 text-900 fw-semi-bold">Date/time</p>
                <p className="mb-0">
                  {data?.transactionTime
                    ? dayjs(data.transactionTime).format(FORMAT_DATE_TIME_II)
                    : ''}
                </p>
              </div>
              <div>
                <p className="mb-0 text-900 fw-semi-bold">Receipt #</p>
                <p className="mb-0">
                  {data?.receiptUrl ? (
                    <a href={data.receiptUrl} target="_blank" rel="noopener noreferrer">
                      {data?.receiptNumber}
                    </a>
                  ) : (
                    data?.receiptNumber
                  )}
                </p>
              </div>
              <div>
                <p className="mb-0 text-900 fw-semi-bold">Payment method</p>
                <SubsidyPaymentMethod cardNumber={data?.cardNumber} />
              </div>
              <div>
                <p className="mb-0 text-900 fw-semi-bold">Updated</p>
                <span>
                  {data?.updatedAt ? dayjs(data.updatedAt).format(FORMAT_DATE_TIME_II) : ''}
                </span>
              </div>
            </div>
          </Card.Body>
        </Card>
        <Row className="g-2">
          <Col xs={12} lg={6}>
            <Card className="h-100">
              <Card.Header className="p-2 bg-primary-subtle">
                <h5>Subsidy Details</h5>
              </Card.Header>
              <Card.Body className="p-2">
                <div className="table-responsive fs--1 position-relative d-flex flex-column h-100">
                  <Table size="sm" className="border-bottom mb-0" bordered>
                    <tbody>{renderRows(data, subsidyTransactionRows)}</tbody>
                  </Table>
                  <Table size="sm" className="border-bottom mt-5" bordered>
                    <tbody>{renderRows(data, subsidyPaymentRows)}</tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SubsidyTransactionDetail;
